import React, { useRef } from "react";
import Audiences from "./sections/Audiences";
import Footer from "./sections/Footer";
import Header from "./sections/Header";
import Hero from "./sections/Hero";
import HowItWorks from "./sections/HowItWorks";
import Modules from "./sections/Modules";
import ProductShots from "./sections/ProductShots";
import RiskZones from "./sections/RiskZones";
import Security from "./sections/Security";
import StatBand from "./sections/StatBand";
import Traction from "./sections/Traction";
import usePublicPageShell from "./hooks/usePublicPageShell";
import useRevealOnScroll from "./hooks/useRevealOnScroll";
import { useTranslation } from "react-i18next";

/**
 * Public marketing page.
 *
 * Renders with no authentication, no API call and no app chrome — it must work
 * with the backend completely down.
 *
 * Section order follows the Trust & Authority + Conversion pattern:
 * scale -> solution -> proof -> path to contact.
 */
export default function Landing() {
  const rootRef = useRef(null);
  const { t } = useTranslation();

  // Releases #root from height:100vh so the document scrolls, and keeps
  // <html lang> in sync. Shared with the legal pages.
  usePublicPageShell();
  useRevealOnScroll(rootRef);

  return (
    <div ref={rootRef} className="min-h-screen bg-white font-inter antialiased">
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:rounded-lg focus:bg-white focus:px-4 focus:py-3 focus:text-black-landing focus:shadow-sm focus:ring-2 focus:ring-primary"
      >
        {t("landing.nav.skip_to_content")}
      </a>

      <Header />

      <main id="main">
        <Hero />
        <StatBand />
        <HowItWorks />
        <RiskZones />
        <Modules />
        <ProductShots />
        <Audiences />
        <Traction />
        <Security />
        {/* <ContactCTA /> */}
      </main>

      <Footer />
    </div>
  );
}
